import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicPageModule } from "ionic-angular";
import { MoreButtonsPicker } from "./more-buttons-picker";
import { CalendarButtonModule } from "../../calendar-button/calendar-button.module";
import { TaskListButtonModule } from "../../task-list-button/task-list-button.module";
import { SyncManagerButtonModule } from "../../../modules-other/sync-manager-button/sync-manager-button.module";

@NgModule({
    imports: [
        CommonModule,
        IonicPageModule.forChild(MoreButtonsPicker),
        CalendarButtonModule,
        SyncManagerButtonModule,
        TaskListButtonModule
    ],
    declarations: [
        MoreButtonsPicker
    ],
    entryComponents: [
        MoreButtonsPicker
    ]
})
export class MoreButtonsPickerModule {}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/nav-bar/more-buttons-picker/more-buttons-picker.module.ts